import TextField, { TextFieldProps } from '@mui/material/TextField';
import {
  FieldHelperProps,
  FieldHookConfig,
  FieldInputProps,
  FieldMetaProps,
  useField
} from 'formik';
import { ChangeEvent } from 'react';
import { requiredValidator } from 'sd-formik-validators';
import { StyledTextField } from './StyledTextField';

interface FormTextFieldProps
  extends Omit<TextFieldProps<'standard'>, 'onChange'> {
  idx?: string;
  isRequired: boolean;
  maxCharacters?: number;
  alphaOnly?: boolean;
  onChange?: (
    e: ChangeEvent,
    a: {
      field: FieldInputProps<string>;
      meta: FieldMetaProps<string>;
      helpers: FieldHelperProps<string>;
    }
  ) => void;
}

export default function FormTextField({
  idx = '',
  isRequired,
  maxCharacters = 500,
  name,
  onChange = undefined,
  label = '',
  alphaOnly = false,
  ...props
}: FormTextFieldProps) {
  const [field, meta, helpers] = useField({
    name,
    validate: isRequired ? requiredValidator : undefined
  });

  function _handleChange(e) {
    if (maxCharacters && e.target.value.length > maxCharacters) return;
    if (alphaOnly)
      e.target.value = e.target.value.toUpperCase().replace(/[^A-Z]/gi, '');
    if (!onChange) {
      field.onChange(e);
      return;
    }
    onChange(e, {
      field,
      meta,
      helpers
    });
  }

  return (
    <StyledTextField
      id={idx}
      type="text"
      {...field}
      value={(field && field.value) || ''}
      onChange={_handleChange}
      variant="outlined"
      margin="none"
      error={!!(meta.touched && meta.error)}
      helperText={!!(meta.touched && meta.error) ? meta.error : ''}
      autoComplete="off"
      label={label}
      required={isRequired}
      style={{
        ...props.style,
        marginBottom: Boolean(meta.touched && meta.error)
          ? '4px'
          : (!!props && !!props.style && props.style.marginBottom) || ''
      }}
      {...props}
    />
  );
}
